import React, { Component } from 'react';
import { Row, Col, Card, Container,Form, } from 'react-bootstrap';
import { components } from 'react-select'
import '../_quiz.scss';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import moment from 'moment';
import EditTimeModal from './EditTimeModal';
import TableSearchwithStudentResult from '../../questioners/manage_questin_papers/TableSearchwithStudentResult';
import SelectBoxWithDisabledOption from '../../selectdropdown/SelectBoxWithDisabledOption';

const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
};

class ManageLecPaperSection extends Component {
    constructor(props) {
        super(props)
        this.state = {
            viewType:"draft",
            modalTimeQuiz:false,
            setTimePaperDetails:"",
            start_time_pop:"",
            examPaperTypevalue:{ value: "5", label: "CC Quiz" },
            examPaperType:"5",
            getExamPaperTypeOptions:[],
            end_time_pop:"",
            extra_time_duration:""

            
        }
        this.onClickEdit = this.onClickEdit.bind(this);
    }
    componentDidMount() {
         let examPaperType1Arr=[];
 
         for (let i = 0; i <= this.props.getExamModelTypes.length; i++) {
             let idata = this.props.getExamModelTypes[i];
             if (idata != undefined) {
                 const newObj = {
                     value: idata.id,
                     label: idata.exam_model,
                 }
                 
                 examPaperType1Arr.push(newObj);
 
             }
 
         }
         
 
         this.setState({
            getExamPaperTypeOptions:examPaperType1Arr
         });
     }

     handleSelect(val) {
        this.setState({
            viewType: val
        })
    }

     selecthandleInput1Change = async(ename, evalue) => {
       
        console.log("selecthandleInputChange", ename, evalue);
        const name = ename;
        const value = evalue;
       if(name == "examPaperType"){
            let examModel1Types = this.props.getExamModelTypes.find((a) => a.id == value);
            this.setState({
                examPaperTypevalue: {
                    value: examModel1Types.id,
                    label: examModel1Types.exam_model
                }
            });
        }
        
        this.setState({ [name]: value});
       
    }

    onClickEdit(paper,type) {
        let item = {}
       
        console.log("pppooo", paper);
        this.props.history.push("/lec_paper_generator/edit_lec_paper/EditTestSection", {
            edit: true,
            examDetails: paper,
            globals: this.props.globals,
            editType:type
        });
    }
   
    onClickTimeModal = (paper,start_time,end_time,time_duration) => {
        this.setState({ 
            modalTimeQuiz: true,
            setTimePaperDetails:paper,
            start_time_pop:start_time,
            end_time_pop:end_time,
            extra_time_duration:time_duration
        })
        
    }

    getClassName = (classid) => {
        let className = "";
        if (classid == 1) {
            className = "Class XI";
        } else if (classid == 2) {
            className = "Class XII";
        }

        return className;
    }

    tableData = (savedPapers) => {
        let getArray = [];

        savedPapers.map(item => {
            const newObject = {
                test_name :item.name,
                no_of_questions:item.total_question_count,
                class_id:item.class,
                //section:item.section,
                test_duration:item.time_duration,
                start_time:moment.unix(item.start_time).format("DD-MM-YYYY LT"),
                //edit_paper:<button class="btn btn-primary effect" onClick={() => this.onClickEdit(item,"normal")}><i class="fas fa-edit"></i> Edit</button>,
                edit_start_time:<button class="btn btn-primary effect" onClick={() => this.onClickTimeModal(item,item.start_time,item.end_time,item.time_duration)}><i class="fas fa-edit"></i> Time</button>
            }
            getArray.push(newObject);
        })
        
        return getArray;
    }
   
    tableData1 = (data) => {
        let getArray = [];

        data.map(item => {
            const newObject = {
                test_name :item.exam_name,
                class_id:this.getClassName(item.class_id),
                test_duration:item.time_duration,
                total_students:item.total_students,
                start_time:moment.unix(item.start_time).format("DD-MM-YYYY LT"),
                //edit_paper:<button class="btn btn-primary effect" onClick={() => this.onClickEdit(item,"normal")}><i class="fas fa-edit"></i> Edit</button>,
                edit_start_time:<button class="btn btn-primary effect" onClick={() => this.onClickTimeModal(item,item.start_time,item.end_time,item.time_duration)}><i class="fas fa-edit"></i> Time</button>
            }
            getArray.push(newObject);
        })
        
        return getArray;
    }

    articlecolumns = [
        {
          dataField: "test_name",
          text: "Test Name",
          sort: true,
        },
        {
            dataField: "no_of_questions",
            text: "No of Questions",
            sort: true,
        },
        {
            dataField: "class_id",
            text: "Class",
            sort: true,
        },
        /*{
            dataField: "section",
            text: "Section",
            sort: true,
        },*/
        {
          dataField: "test_duration",
          text: "Test Duration (Min)",
        },
        {
          dataField: "start_time",
          text: "Start Date & Time",
        },
        /*{
          dataField: "edit_paper",
          text: "Edit Questions",
          sort: true,
        },*/
        {
          dataField: "edit_start_time",
          text: "Set Start Time",
          sort: true,
        },
      ];


      articlecolumns1 = [
        {
          dataField: "test_name",
          text: "Test Name",
          sort: true,
        },
       
        {
            dataField: "class_id",
            text: "Class",
            sort: true,
        },
        
        {
          dataField: "test_duration",
          text: "Test Duration (Min)",
        },
        {
            dataField: "total_students",
            text: "Total Students",
            sort: true,
          },
        {
          dataField: "start_time",
          text: "Start Date & Time",
        },
        /*{
          dataField: "edit_paper",
          text: "Edit Questions",
          sort: true,
        },*/
        {
          dataField: "edit_start_time",
          text: "Set Start Time",
          sort: true,
        },
      ];

      
    render() {
        let testSavedPapers=[];
        let scheduledLecPapers=[];
        
        if(this.props.savedPapers != undefined){
            testSavedPapers = this.props.savedPapers.filter(item => parseInt(item.exam_model_type_id) == parseInt(this.state.examPaperType))
        }
        if(this.props.getLecScheduledPaper != undefined){
            this.props.getLecScheduledPaper.map(item => {
                console.log("dddddddddddd",item.schedulequiz)
                scheduledLecPapers = item.schedulequiz.filter(item1 => parseInt(item1.exam_model_type_id) == parseInt(this.state.examPaperType))
            });
        }
        
        console.log("aravindsssssssssss",testSavedPapers)
        console.log("aravindsssssssssss",scheduledLecPapers)

        return (
            <div className='quiz_section'>
              <Row>
                <Col sm={3}>
                        <Form.Label className="text-uppercase font-weight-bold">Select Exam Paper Type</Form.Label>
                        <SelectBoxWithDisabledOption
                            stateData={this.state.examPaperTypevalue}
                            handleChange={this.selecthandleInput1Change}
                            name="examPaperType"
                            options={this.state.getExamPaperTypeOptions}
                            placeholderName={'Exam Paper Type'}
                            dropdownIndicator={{ DropdownIndicator }}
                        />
                </Col>
              </Row>
              <Row>
                  <Col sm={12}>
                    <ul className='list-inline question_sel_cls mt-3'>
                        <li  className={this.state.viewType == "draft" ? "active mr-4" : "mr-4"} onClick={() => this.handleSelect("draft")}>Draft Exams</li>
                        <li className={this.state.viewType == "scheduled" ? "active mr-4" : "mr-4"} onClick={() => this.handleSelect("scheduled")}>Scheduled Exams</li>
                      </ul>
                  </Col>
              </Row>
              <Row>
                <Col sm={12}>
                    {
                        this.state.viewType === "draft" ?
                        (
                            <Card as={Card.Body} className="p-3">
                                <h4 className="text-center mb-4">Draft Exams</h4>
                                {
                                    (
                                        this.props.savedPapers != undefined && testSavedPapers.length>0 ?
                                        (
                                            <TableSearchwithStudentResult
                                                parentData={this.tableData(testSavedPapers)}
                                                particlecolumns={this.articlecolumns}
                                            />
                                        )
                                        :
                                        (<h6 className="text-center">Exams Not Available</h6>)

                                    )
                                }
                                
                            </Card>
                        )
                        :
                        (
                            <Card as={Card.Body} className="p-3">
                                <h4 className="text-center mb-4">Scheduled Exams</h4>
                                {
                                   
                                    (
                                        scheduledLecPapers.length>0  ?
                                        (
                                            <TableSearchwithStudentResult
                                                parentData={this.tableData1(scheduledLecPapers)}
                                                particlecolumns={this.articlecolumns1}
                                            />
                                        )
                                        :
                                        (<h6 className="text-center">Exams Not Available</h6>)

                                    )
                                }
                                
                            </Card>
                        )

                    }
                    
                </Col>
              </Row>
              <EditTimeModal
                    setTimePaperDetails={this.state.setTimePaperDetails}
                    show={this.state.modalTimeQuiz}
                    onHide={() => this.setState({ modalTimeQuiz: false})}
                    start_time_pop={this.state.start_time_pop}
                />
              
              </div>
        )
    }
}


export default withRouter(ManageLecPaperSection);
   


